function pageTitleFromDroppedItem (dropped) {

  if (!dropped || dropped.type === 'value' || dropped.type === 'dropdown') return ''
  if (!dropped.pageUniqueTitle) return ''

  return dropped.pageUniqueTitle
}

module.exports = pageTitleFromDroppedItem
